import * as CNPJ from 'cnpj';
import * as CPF from 'cpf';
import * as R from 'ramda';

export const onlyNumbers = (value: any) => {
  if (value === undefined || value === null) {
    return '';
  }
  return value.replace(/\D/g, '');
};

export const onlyNumbersAndLetters = (value: string) => value.replace(/[^a-zA-Z0-9 ]/g, '');

export const unmaskCpfCnpj = (value?: string | null): string =>
  value ? value.replace(/[^A-Za-z0-9]/g, '').toUpperCase() : '';

export const yupValidateCPF = (value: any) => {
  if (!value) {
    return true;
  }
  return CPF.isValid(onlyNumbers(value));
};

export const yupValidateCNPJ = (value: any) => {
  if (!value) {
    return true;
  }
  return CNPJ.validate(unmaskCpfCnpj(value));
};

export const yupValidateZipCode = (value: any) => {
  if (value && value.startsWith('00')) {
    return false;
  }
  const zipCodeFormat = /\d{5,5}-\d{3,3}/g;
  const zipCode = /\d{8,8}/g;
  const formattedZipCodeRegex = zipCodeFormat.test(value);
  const zipCodeRegex = zipCode.test(value);
  return formattedZipCodeRegex || zipCodeRegex || R.isNil(value);
};

// valida somente se existir algum valor
const isCelular = (value: string | null | undefined): boolean => {
  if (R.isNil(value)) {
    return true;
  }

  if (value.length === 0) {
    return true;
  }
  return !!(
    value &&
    value.replace(/[^\d]/g, '').length === 11 &&
    value.replace(/[^\d]/g, '')[2] === '9'
  );
};

// valida somente se existir algum valor
const isTelefoneComercial = (val: string | null | undefined): boolean => {
  if (R.isNil(val)) {
    return true;
  }

  if (val.length === 0) {
    return true;
  }
  return !!(val && val.replace(/[^\d]/g, '').length === 10);
};

export const validateTelefoneComercialOuCelular = (val: string | null | undefined): boolean =>
  isTelefoneComercial(val) || isCelular(val);

export const validateTouchEnabled = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

export const isValidEmail = (email?: string) => {
  if (!email) {
    return false;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
